import React, { Component } from 'react';
import SandboxHistoryItemComponent from './SandboxHistoryItemComponent';
import Icon from '../../../icons/Icon';
import { SandboxHistorySchema } from '../../../../../server/src/lib/domain/stream/transaction/TransactionDomains';
import LanguageUtil from '../../../util/LanguageUtil';

class SandboxItemContainer extends Component<Props, State> {
  public state = new State();

  render() {
    const { histories, label, setHistory } = this.props;
    const { isOpen } = this.state;
    return (
      <div className={'flex flex-col w-full justify-center border-b-[1px] py-1'}>
        <div className={'flex w-full justify-between items-center'}>
          <div className={'flex items-center w-full'}>
            <div onClick={this.onClickArrow} className={'cursor-pointer'}>
              <Icon icon={isOpen ? 'arrow-down' : 'arrow-right'} className={'text-[#9CA3AF]'} size={20} />
            </div>
            <div className={'text-md text-[#9CA3AF] w-full flex items-center '}>{label}</div>
          </div>
        </div>
        <div className={`${isOpen ? 'block' : 'hidden'} max-h-[200px] overflow-y-scroll custom-scroll`}>
          {histories?.map((history, index) => (
            <SandboxHistoryItemComponent setHistory={setHistory} key={index} history={history} />
          ))}
        </div>
      </div>
    );
  }

  public componentDidMount() {
    if (this.props.label == LanguageUtil.get({ id: 'common.label.pinned', defaultMessage: 'PINNED' })) {
      this.setState({ isOpen: true });
    }
  }

  private onClickArrow = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
}

interface Props {
  histories: SandboxHistorySchema[];
  label: string;
  setHistory: (history: SandboxHistorySchema) => void;
}

class State {
  isOpen: boolean = false;
}

export default SandboxItemContainer;
